import { render, staticRenderFns } from "./ProductTableElement.vue?vue&type=template&id=288cac82&scoped=true&"
import script from "./ProductTableElement.vue?vue&type=script&lang=js&"
export * from "./ProductTableElement.vue?vue&type=script&lang=js&"
import style0 from "./ProductTableElement.vue?vue&type=style&index=0&lang=css&"
import style1 from "./ProductTableElement.vue?vue&type=style&index=1&id=288cac82&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "288cac82",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VIcon,VSpacer})


/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('288cac82')) {
      api.createRecord('288cac82', component.options)
    } else {
      api.reload('288cac82', component.options)
    }
    module.hot.accept("./ProductTableElement.vue?vue&type=template&id=288cac82&scoped=true&", function () {
      api.rerender('288cac82', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Papers/pages/Paper/components/Elements/ProductTableElement.vue"
export default component.exports